import React from "react";
import { useLang } from "../context/LanguageContext";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export default function LanguageSwitcher({ compact = false }) {
    const { lang, setLang, supported, labels } = useLang();
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    // h-10 (a FIXED height, not min-h) matches the
                    // Dashboard/Sign-out pill buttons this sits next to in
                    // every header that uses `compact`. This used to be
                    // min-h-[40px] on all three — a *minimum* only pins the
                    // height while each button's own content already fits
                    // under 40px, which is true once the real webfont has
                    // loaded, but not necessarily during the brief window a
                    // fallback system font is showing before it swaps in
                    // (different fonts, different line-height) — for that
                    // window a taller fallback could push one pill past
                    // 40px while its neighbors stayed at exactly 40, which
                    // is what made the row look misaligned. A fixed height
                    // can't drift with the font, so it's not just visually
                    // centered, it's the same 40px box no matter what.
                    className={`inline-flex items-center justify-center gap-2 rounded-full bg-white px-4 py-2 font-display font-semibold text-charcoal hover:bg-sand ${compact ? "text-sm h-10" : ""}`}
                    data-testid="language-switcher-trigger"
                >
                    <Globe className="w-4 h-4" strokeWidth={2.5} />
                    <span>{labels[lang] || lang.toUpperCase()}</span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-white border-sand rounded-2xl p-2 min-w-[180px]">
                {(supported || []).map((code) => (
                    <DropdownMenuItem
                        key={code}
                        onSelect={() => setLang(code)}
                        data-testid={`language-option-${code}`}
                        className={`rounded-xl px-3 py-2 cursor-pointer font-semibold ${lang === code ? "bg-honey text-charcoal" : "text-charcoal hover:bg-sand"}`}
                    >
                        {labels[code] || code}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
